import { Box, Typography } from '@material-ui/core'
import { getDefaultNormalizer } from '@testing-library/dom'
import React from 'react'
import AppLogo from '../components/shared/AppLogo'

export default function Maintenance() {
    return (
        <Box style={{textAlign:"left",width:"70%", paddingTop:"200px", paddingLeft:"20%"}}>
           <AppLogo width="90px" />
           <Typography variant="h5" color="initial" gutterBottom>
               Maintenance
           </Typography>
           We are currently at maintenance mode. We will be back soon ⚡
           Any quries write at <a href="mailto:name@rapidtables.com">name@rapidtables.com</a>
        </Box>
    )
}
